
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Hint from '../Hint.vue'

@Component({
  components: {
    Hint
  }
})
export default class FieldContainer extends Vue {
  @Prop({ default: null }) label!: string
  @Prop({ default: false }) required!: boolean
  @Prop({ default: false }) readOnly!: boolean
  @Prop({ default: false }) isDisabled!: boolean
  @Prop({ default: null }) labelBackgroundColor!: string | null
  @Prop({ default: '' }) error!: string
  @Prop({ default: '' }) hintHtml!: string
  @Prop({ default: true }) resetErrorOnInput!: boolean

  state: boolean | null = null

  @Watch('error')
  onErrorChanged(value: string) {
    this.state = value ? false : null
  }

  resetError() {
    this.state = null
    this.$emit('reset-error')
  }
}
